export default __webpack_public_path__ + "static/media/curson.b55e6e46.svg";